function toDouble(iNum) {
    iNum = parseInt(iNum);
    return iNum > 9 ? '' + iNum : '0' + iNum;
}
export default {
    formatDate(oDate, opt) {
        opt = opt || 'yyyy-MM-dd';
        if (!oDate) {
            oDate = new Date();
        } else if (typeof oDate == 'string') {
            var l = oDate.length;
            oDate = new Date(oDate);
            l == 10 && oDate.setHours(0);
        }
        var year = oDate.getFullYear();
        var month = oDate.getMonth() + 1;
        var date = oDate.getDate();

        var hour = oDate.getHours();
        var minute = oDate.getMinutes();
        var second = oDate.getSeconds();
        var milli = oDate.getMilliseconds();

        var format = opt;

        format = format.replace(/[yy]+/ig, function (math) {
            return (year + '').substring(4 - math.length);
        });
        format = format.replace(/M+/g, function (math) {
            return math.length == 2 ? toDouble(month) : month;
        });
        format = format.replace(/d+/ig, function (math) {
            return math.length == 2 ? toDouble(date) : date;
        });

        format = format.replace(/h+/ig, function (math) {
            return math.length == 2 ? toDouble(hour) : hour;
        });
        format = format.replace(/m+/g, function (math) {
            return math.length == 2 ? toDouble(minute) : minute;
        });
        format = format.replace(/s+/ig, function (math) {
            return math.length == 2 ? toDouble(second) : second;
        });

        return format;
    },
    //json转list
    toList(obj) {
        let list = [];
        for (var key in obj) {
            list.push({ id: key, name: obj[key] });
        }
        return list;
    },
    //格式化url
    formatUrl(oOption, url, domain?) {
        domain = domain || '';
        let origin = window.location.origin;
        let absoluteUrl = origin + domain + url;
        oOption = oOption || {};
        let i = absoluteUrl.indexOf('#');
        let sUrl = absoluteUrl.substring(0, i == -1 ? absoluteUrl.length : i);
        let sHash = i == -1 ? '' : absoluteUrl.substring(i);
        for (var attr in oOption) {
            var re = new RegExp('([\\?|&]' + attr + '=)[^&]*', 'igm');
            if (re.test(sUrl)) {
                sUrl = sUrl.replace(re, '$1' + encodeURI(oOption[attr]));
            } else {
                sUrl = sUrl.replace(/(\?+|&+)$/, '');
                var and = sUrl.indexOf('?') == -1 ? '?' : '&';
                sUrl += and + attr + '=' + oOption[attr];
            }
        }
        return sUrl + sHash;
    },
    //导出文件
    exportFiles(url) {
        url = encodeURI(url);
        var oIfm = document.createElement('iframe');
        oIfm.style.cssText = 'position:fixed;left:0;top:0;width:1px;height:1px;z-index:-99;opacity:0;';
        //onload事件一般不管用，下载文件时chrome不触发
        oIfm.onload = function () {
            var I = this;
            setTimeout(function () {
                // @ts-ignore
                I.parentNode.removeChild(I);
            }, 5000);
        };
        oIfm.setAttribute('src', url);
        document.body.appendChild(oIfm);
    },
    isArray(object){
    return object && typeof object === 'object' &&
        Array == object.constructor;
    },
    getCacheData () {
        return JSON.parse(window.localStorage.getItem('access-user'))||null;
    },
    findIndex(list, obj) {
        for (var i = 0; i < list.length; i++) {
            if (list[i] == obj) {
                return i;
            }
        }
        return -1;
    },
    matchIndex(list, listObj) {
        list.forEach(item => {
            item = (<any>Object).assign(item, listObj[item.recordIndex]);
        });
        return list;
    }
}
